// frontend/admin-portal/src/components/settings/items/SelectInput.jsx
import React from "react";

export default function SelectInput({
  value,
  onChange,
  options = [],
  disabled = false,
}) {
  const handle = (e) => {
    if (typeof onChange === "function") onChange(e.target.value);
  };
  return (
    <select
      className="fh-input"
      value={value ?? ""}
      onChange={handle}
      disabled={disabled}
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
